// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OfflineToast__container-bf00cf.OfflineToast__low-priority-toast-b6e894 {
  z-index: 999;
}

.OfflineToast__wrapper-b78378 {
  text-align: left;
  font: var(--font-body-5);
  letter-spacing: var(--font-spacing-body-5);
  color: var(--base-0);
  display: inline-flex;
  align-items: center;
}

.OfflineToast__loader-be65f2 {
  width: 14px;
  height: 14px;
  margin-inline-end: 6px;
  position: relative;
  bottom: -1px;
}

.OfflineToast__loader-be65f2 .OfflineToast__stop-d709f9 {
  stop-color: var(--base-0);
}`, "",{"version":3,"sources":["webpack://./src/main/Popups/OfflineToast/OfflineToast.styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,gBAAA;EACA,wBAAA;EACA,0CAAA;EACA,oBAAA;EAEA,oBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;AAAF;;AAGA;EACE,yBAAA;AAAF","sourcesContent":[".container.low-priority-toast {\n  z-index: 999;\n}\n\n.wrapper {\n  text-align: left;\n  font: var(--font-body-5);\n  letter-spacing: var(--font-spacing-body-5);\n  color: var(--base-0);\n\n  display: inline-flex;\n  align-items: center;\n}\n\n.loader {\n  width: 14px;\n  height: 14px;\n  margin-inline-end: 6px;\n  position: relative;\n  bottom: -1px;\n}\n\n.loader .stop {\n  stop-color: var(--base-0);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `OfflineToast__container-bf00cf`,
	"low-priority-toast": `OfflineToast__low-priority-toast-b6e894`,
	"lowPriorityToast": `OfflineToast__low-priority-toast-b6e894`,
	"wrapper": `OfflineToast__wrapper-b78378`,
	"loader": `OfflineToast__loader-be65f2`,
	"stop": `OfflineToast__stop-d709f9`
};
module.exports = ___CSS_LOADER_EXPORT___;
